// extracted by mini-css-extract-plugin
export default {"ctaSection":"CTASection_ctaSection__XBan1","container":"CTASection_container__emTzt","ctaButton":"CTASection_ctaButton__GZTpJ"};